module.exports = __webpack_public_path__ + "static/media/mag.836c9cb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/mag.png
// module id = 51
// module chunks = 0